import * as React from "react";
import type { SVGProps } from "react";
const SvgBag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.6 8.342a3.6 3.6 0 1 1-7.2 0m-3.673 12.6h14.546c1.285 0 2.327-1.023 2.327-2.284L20.11 5.342c0-1.261-1.043-2.284-2.328-2.284H5.927C4.642 3.058 3.6 4.081 3.6 5.342L2.4 18.658c0 1.261 1.042 2.284 2.327 2.284"
    />
  </svg>
);
export default SvgBag03;
